import { GET_COUNTRIES } from "../constants/constants";

const initialSessionState = { countries: [] };

export default (state, action) => {
  const currentState = state || initialSessionState;
  switch (action.type) {
    case GET_COUNTRIES:
      return {
        ...currentState,
        countries: [...action.countries],
      };
    default:
      return currentState;
  }
};

export const getCountries = (state) => state.countriesReducer.countries;
